import React, { useState, useEffect } from "react";
import DashboardHeader from "../../components/DashboardHeader";
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import all_orders from "../../constants/orders";
import { calculateRange, sliceData } from "../../utils/table-pagination";

import "../styles.css";
import DoneIcon from "../../assets/icons/done.svg";
import CancelIcon from "../../assets/icons/cancel.svg";
import RefundedIcon from "../../assets/icons/refunded.svg";
import { toast } from "react-toastify";
import { blogstore, PostTeams } from "../../network/Network";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import TextEditor from "../../components/texteditor/Texteditor";

function Orders() {
  const dispatch = useDispatch();
  const [blogstoress, setblogstoress] = useState([]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [isOpenModal, setIsOpenModal] = useState(false);
  // const [convertedText, setConvertedText] = useState("Some default content");
  const [name, setName] = useState();
  const [title, setTitle] = useState();
  const [img, setimg] = useState();
  const [state, setState] = useState();
  const [image, setImage] = useState();
  const [des, setdes] = useState();
  const [loading, setLoading] = useState(false);
  const [spinLoad, setSpinLoad] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState();
  const [editData, setEditData] = useState([]);
  let limit = 10;
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );
  const handlePageClick = async (data) => {
    console.log(data.selected);
    setCurrentPage(data?.selected + 1);
  };

  const [newFile, setNewFile] = useState()
  const [fileupload, setFileupload] = useState()

  const handleImageUpload = (e) => {
		e.preventDefault();
		const reader = new FileReader();
		const file = e.target.files[0];
		reader.onloadend = () => {
			setNewFile(file);
      console.log("file", file)
			setFileupload(reader.result);
		};
		reader.readAsDataURL(file);
		// setUploadLoading(true);
	};

  const Addnewblog =  (e) => {
    e.preventDefault();
    setLoading(true);
    let data =  new FormData();
    data.append("title", title);
    data.append("Image", newFile);
    data.append("description", des);
    console.log("run")
    blogstore(data)
      .then((res) => {
        console.log(res);
        // for (var i = 0; i < res?.data?.response?.data.length; i++) {
        //   if (res?.data?.response?.data[i].slug === "blogshow") {
        //     setTitle(res?.data?.data[i]?.title);
        //     setImage(res?.data?.data[i]?.image);
        //     setdes(res?.data?.data[i]?.des);
        //     console.log("first", res.data.response.data[i]);
        //   }
        // }
        // dispatch(AllServices(res?.data?.response?.data));
        setLoading(false);
        setIsOpenModal(false);
        setTitle(" ");
        setImage(" ");
        setdes(" ");
      })
      .catch((err) => {
        console.log(err);
        toast.error(err?.data?.message);
        setLoading(false);
        setTitle(" ");
        setImage(" ");
        setdes(" ");
      });
  };

  useEffect(() => {

  }, [limit, currentPage]);

  return (
    <div className="dashboard-content">
      {/* <DashboardHeader btnText="New Order" /> */}

      <div className="dashboard-content-container">
        <div className="blog-img">
          <label for="exampleFormControlTextarea1">Blog-image</label>
          <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  multiple={false}
                />
          <p>{Image}</p>
        </div>

        <div className="blog-input">
          <label for="exampleFormControlTextarea1">Blog-heading</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
          />
          <div className="blog-btn">{/* <button>Edit</button> */}</div>
        </div>

        <div className="blog-text">
          <div class="form-group ">
            <label for="exampleFormControlTextarea1">Blog-description</label>
            {/* <textarea
              value={des}
              onChange={(e) => setdes(e.target.value)}
              class="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            ></textarea> */}
             <TextEditor
                      placeholder={"Enter"}
                      content={des}
                      setContent={setdes}
                    />
          </div>

          <div className="blog-btn">{/* <button>Edit</button> */}</div>
        </div>

        <div className="blog-date">
          <label for="exampleFormControlTextarea1">Blog-date</label>
          <input type="text"></input>

          <div className="blog-btn">
            {/* <button>Edit</button> */}
            <button
              disabled={loading}
              onClick={(e) => {
                Addnewblog(e);
              }}
            >
              {loading ? "Loading..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Orders;
